import {
	handleKeyDown,
	handleResizeStart,
	handleTransitionEnd,
	stopLogoPropagation,
} from './Sidebar.utils'
import { useEffect, useRef, useState } from 'react'

import { useSidebarResizeProps } from './Sidebar.types'

export const useSidebarResize = (): useSidebarResizeProps => {
	const [expanded, setExpanded] = useState<boolean>(true)

	const expandedRef = useRef<boolean>(expanded)
	const resizingRef = useRef<boolean>(false)
	const widthRef = useRef<number | null>(null)
	const sidebarContentRef = useRef<HTMLDivElement>(null)

	const toggleExpanded = (expand: boolean): void => {
		sidebarContentRef.current.style.width = expand
			? `${widthRef.current}px`
			: null

		setExpanded(expand)
	}

	const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
		handleKeyDown(event, { expanded, toggleExpanded, widthRef })
	}

	useEffect(() => {
		expandedRef.current = expanded
	}, [expanded])

	return {
		handleKeyDown: onKeyDown,
		handleResizeStart: (): void => {
			handleResizeStart({
				sidebarContentRef,
				resizingRef,
				expanded,
				toggleExpanded,
				widthRef,
			})
		},
		handleTransitionEnd: (
			event: React.TransitionEvent<HTMLDivElement>
		): void => {
			handleTransitionEnd(event, { sidebarContentRef })
		},
		stopLogoPropagation,
		expanded,
		setExpanded,
		sidebarContentRef,
		widthRef,
	}
}
